import { render, staticRenderFns } from "./BaseConfirm.vue?vue&type=template&id=ba464f88&scoped=true&"
import script from "./BaseConfirm.vue?vue&type=script&lang=js&"
export * from "./BaseConfirm.vue?vue&type=script&lang=js&"
import style0 from "./BaseConfirm.vue?vue&type=style&index=0&id=ba464f88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba464f88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba464f88')) {
      api.createRecord('ba464f88', component.options)
    } else {
      api.reload('ba464f88', component.options)
    }
    module.hot.accept("./BaseConfirm.vue?vue&type=template&id=ba464f88&scoped=true&", function () {
      api.rerender('ba464f88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseConfirm.vue"
export default component.exports